define('lib/clipboard',['require','exports','module'],function(require,exports,module){
	"use strict";

	module.exports = function (text) {
		var el = document.createElement('textarea');
		el.value = text;
		el.setAttribute('readonly', '');
		el.style.position = 'absolute';
		el.style.left = '-9999px';
		document.body.appendChild(el);
    var selected = document.getSelection().rangeCount > 0 ?
      document.getSelection().getRangeAt(0) : false;
		el.select();
		document.execCommand('copy');
		document.body.removeChild(el);
		if (selected) {
			document.getSelection().removeAllRanges();
			document.getSelection().addRange(selected);
		}
	};

});

